<template>
	<div>
		<div class="d-flex justify-center mb-3">
			<v-btn color="info" elevation="0" small @click="assuranceRequirementsDialog = true">
				مدیریت اطلاعات پایه شرایط متقاضی
			</v-btn>
		</div>
		<v-divider></v-divider>
		<div v-if="loading">
			<div class="success--text text-h4 text-center">
				در حال دریافت اطلاعات...
			</div>
		</div>
		<div v-else>
			<div v-if="!items.length">
				<h3 class="text-center red--text mt-3">شرایط متقاضی برای این نوع وام ثبت نشده است</h3>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="secondary" dark @click="add" small>
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن شرط
					</v-btn>
				</div>
			</div>
			<div v-else>
				<v-card v-for="(item, index) in items" :key="item.id + index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
					<v-card-title class="d-flex justify-space-between pa-0 mb-2">
						<h3>شرایط شماره {{ index + 1 }}</h3>
						<div class="d-flex">
							<v-btn @click="remove(item, index)" :loading="removeLoading === `${item.id}${index}`" class="ml-1" x-small fab color="red" dark title="حذف">
								<v-icon>
									mdi-trash-can-outline
								</v-icon>
							</v-btn>
							<v-btn @click="save(item, index)" :loading="submitLoading === `${item.id}${index}`" class="" x-small fab color="success" dark title="ذخیره">
								<v-icon>
									mdi-content-save-outline
								</v-icon>
							</v-btn>
						</div>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="mb-2">
						<v-row class="">
							<v-col cols="12" md="4" v-for="(ass, index) in ass_requirements" :key="ass.id" class="py-0 my-0">
								<div>{{ ass.title }}</div>
								<v-select v-model="item.assuranceRequirementItemIds[ass.id]" multiple :items="ass.assuranceRequirementItems" item-text="title" item-value="id" dense outlined></v-select>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="secondary" dark @click="add" small>
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن شرایط
					</v-btn>
				</div>
			</div>
		</div>

		<v-dialog v-model="assuranceRequirementsDialog" scrollable max-width="700px">
			<AssuranceRequirements v-if="assuranceRequirementsDialog" @close="assuranceRequirementsDialog = false" />
		</v-dialog>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'

	export default {
		name: 'LoanAssuranceRequirements',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			AssuranceRequirements: () => import('@/components/forms/AssuranceRequirements.vue'),
		},
		data() {
			return {
				errorMessages: '',
				items: [],
				localData: {},
				submitLoading: false,
				removeLoading: false,
				loading: false,
				assuranceRequirementsDialog: false,
				dialog: false,
				systemTypes: [{
					id: 0,
					title: 'غیر سیستمی'
				},
				{
					id: 2,
					title: 'سیستمی: اعتبارسنجی ایران'
				}]
			}
		},
		computed: {
			ass_requirements: get('assuranceRequirements/all'),
		},
		mounted() {
			this.fetchAssuranceRequirements()
				.then(() => {
					this.loadData()
				})
		},
		methods: {
			fetchAssuranceRequirements: call('assuranceRequirements/fetch'),
			loadData() {
				this.loading = true
				api.get('admin/LoanAssuranceRequirement/ListByLoanId/' + this.data.id, null)
					.then(
						response => {
							this.items = response.map(x => {
								x.editMode = false
								return x
							})
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			async remove(item, index) {
				if (!item) {
					return
				}

				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					this.removeLoading = `${item.id}${index}`
					api.post('admin/LoanAssuranceRequirement/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.items.splice(index, 1)
							})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => {
							this.removeLoading = ``
						})
				}
			},
			save(item, index) {
				console.log("🚀 ~ save ~ item:", item)
				this.submitLoading = `${item.id}${index}`
				var clone = { ...item }
				// for (const key in clone.assuranceRequirementItemIds) {
				// 	const payload = {}
				// 	payload[key] = !clone.assuranceRequirementItemIds[key]?.length ? [] : clone.assuranceRequirementItemIds[key]

				// }
				api.post('admin/LoanAssuranceRequirement/' + (item.id === emptyId ? 'create' : 'edit'), clone)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.loadData()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			add() {
				this.items.push({
					id: emptyId,
					loanId: this.data.id,
					assuranceRequirementItemIds: {}
				})
			}
		},
	}
</script>
<style></style>
